export const FETCH_REQUEST = 'NODE.FETCH_REQUEST';
export const FETCH_SUCCESS = 'NODE.FETCH_SUCCESS';
export const FETCH_FAILURE = 'NODE.FETCH_FAILURE';

export const FETCH_STATE_REQUEST = 'NODE.FETCH_STATE_REQUEST';
export const FETCH_STATE_SUCCESS = 'NODE.FETCH_STATE_SUCCESS';
export const FETCH_STATE_FAILURE = 'NODE.FETCH_STATE_FAILURE';

export const FETCH_MEASUREMENT_REQUEST = 'NODE.FETCH_MEASUREMENT_REQUEST';
export const FETCH_MEASUREMENT_SUCCESS = 'NODE.FETCH_MEASUREMENT_SUCCESS';
export const FETCH_MEASUREMENT_FAILURE = 'NODE.FETCH_MEASUREMENT_FAILURE';

export const FETCH_NODES_WITH_STATES_REQUEST = 'NODE.FETCH_NODES_WITH_STATES_REQUEST';
export const FETCH_NODES_WITH_STATES_SUCCESS = 'NODE.FETCH_NODES_WITH_STATES_SUCCESS';
export const FETCH_NODES_WITH_STATES_FAILURE = 'NODE.FETCH_NODES_WITH_STATES_FAILURE';

export const FETCH_NODES_WITH_MEASUREMENTS_REQUEST = 'NODE.FETCH_NODES_WITH_MEASUREMENTS_REQUEST';
export const FETCH_NODES_WITH_MEASUREMENTS_SUCCESS = 'NODE.FETCH_NODES_WITH_MEASUREMENTS_SUCCESS';
export const FETCH_NODES_WITH_MEASUREMENTS_FAILURE = 'NODE.FETCH_NODES_WITH_MEASUREMENTS_FAILURE';


// WEBPACK FOOTER //
// ./src/constants/Node.ts